import { SelectionAny } from './internal';
export class SelectionAddress extends SelectionAny {
    getAddressLine1() {
        return this.get("ADR1" /* Tag.Address1 */);
    }
    getAddressLine2() {
        return this.get("ADR2" /* Tag.Address2 */);
    }
    getAddressLine3() {
        return this.get("ADR3" /* Tag.Address3 */);
    }
    getCity() {
        return this.get("CITY" /* Tag.City */);
    }
    getState() {
        return this.get("STAE" /* Tag.State */);
    }
    getPostalCode() {
        return this.get("POST" /* Tag.PostalCode */);
    }
    getCountry() {
        return this.get("CTRY" /* Tag.Country */);
    }
}
//# sourceMappingURL=SelectionAddress.js.map